import { Component, OnInit, Input } from '@angular/core';
import { Router } from '@angular/router';
import { PickerController, ViewDidEnter } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { ConstantsApiService } from 'src/app/core/api/constants-api.service';
import { BaseModal } from 'src/app/core/models/classes/base-modal';
import { StorageKeys } from 'src/app/core/models/enums/storage-keys';
import { LoadingService } from 'src/app/core/services/loading.service';
import { ModalService } from 'src/app/core/services/modal.service';
import { StorageService } from 'src/app/core/services/storage.service';
import { FarmDeviceDetailItem } from '../../models/farm-device.model';
import { DetailService } from '../../services/detail.service';

@Component({
  selector: 'app-sensor-selection',
  templateUrl: './sensor-selection.component.html',
  styleUrls: ['./sensor-selection.component.scss'],
})
export class SensorSelectionComponent extends BaseModal implements OnInit, ViewDidEnter {
  @Input() detailItem: FarmDeviceDetailItem
  @Input() page: string;
  @Input() deviceType: string;
  sensorValue: string;
  isFiliz: boolean = false;
  type: string;
  sensorList: Array<any> = [];
  sensorValueId: number;
  constructor(
    private modalService: ModalService,
    private detailService: DetailService,
    private translate: TranslateService,
    private pickerCtrl: PickerController,
    private loadingService: LoadingService,
    private router: Router,
    private storageService: StorageService,
    private constantApiService: ConstantsApiService) {
    super();
    super._modalService = modalService;
  }
  ionViewDidEnter(): void {
    this.storageService.get(StorageKeys.FILIZ_MODE).then(e => {
      if (e.IsSuccess) {
        this.isFiliz = e.Data;
        if (this.isFiliz) {
          this.type = "filiz"
        } else {
          this.type = "trap"
        }
      }
    });
    this.detailService.getSensorList(this.detailItem.DeviceId).subscribe(res => {
      if (res.IsSuccess) {
        this.sensorList = res.Data;
      }
    })
  }

  ngOnInit() {
    super.ngOnInit();
    this.sensorValue = this.detailItem.SelectedSoilSensorType
    this.sensorValueId = this.detailItem.SelectedSoilSensorTypeId;
  }
  async sensorChange() {
    let list = [];
    this.sensorList.forEach(element => {
      list.push({
        text: this.translate.instant('soil-sensor.' + element.ConstantValue),
        value: element.ConstantId
      })
    });
    list.sort((a, b) => a.text.localeCompare(b.text));
    const picker = await this.pickerCtrl.create({
      columns: [{
        name: 'sensorValue',
        options: list
      }],
      buttons: [
        {
          role: 'cancel',
          text: this.translate.instant("general.cancel")
        },
        {
          text: this.translate.instant("general.save"),
          handler: (value) => {
            this.sensorValue = value.sensorValue.text;
            this.sensorValueId = value.sensorValue.value;
          }
        }
      ]
    });

    await picker.present();
}



  saveChanges() {
    this.loadingService.showLoading();
    let payload = {
      "DeviceId": this.detailItem.DeviceId,
      "SensorValue": this.sensorValueId
    }
    this.detailService.selectSensorType(payload).subscribe(res => {
      this.loadingService.hideLoading();
      if (res.IsSuccess) {
        this.modalService.dismissByModalId(this.id, this.sensorValue, "success");
        if (this.page == 'farm-detail') {
          this.router.navigate(["/common/detail"], {
            queryParams: {
              sensorType: this.type,
              farmId: this.detailItem.TempFarmAttId
            }
          });
        }
        else if (this.page == 'profile-detail') {
          this.router.navigate(["/filiz/profile/my-devices-detail"], {
            queryParams: {
              deviceId: this.detailItem.DeviceId,
              deviceType: this.deviceType
            }
          })
        }

      } else {
        this.modalService.dismissByModalId(this.id, null, "error");
      }
    })
  }
}
